import { BasicType } from "@easy-email-pro-core/constants";
import { HtmlNodeElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type HtmlNodeProps = RecursivePartial<HtmlNodeElement["attributes"]> & {
  idx?: string | null;
  children?: React.ReactNode;
  tagName: keyof HTMLElementTagNameMap;
};

export function HtmlNode(props: HtmlNodeProps) {
  const { tagName, children: propsChildren, idx, ...rest } = props;
  const node: HtmlNodeElement = {
    type: BasicType.HTML_NODE,
    data: { tagName: tagName },
    attributes: { ...rest } as any,
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
